export const ACTION_TYPES = {
  GENERATE_BP: 'logistic/GENERATE_BP',
  SHOW_GENERATE_BP_ERROR: 'logistic/SHOW_GENERATE_BP_ERROR',
  HIDE_GENERATE_BP_ERROR: 'logistic/HIDE_GENERATE_BP_ERROR',
  GET_BENEFIT: 'logistic/GET_BENEFIT',
  GET_GEOLOCALISATION: 'logistic/GET_GEOLOCALISATION',
  SHOW_GEOLOCALISATION_MODAL: 'logistic/SHOW_GEOLOCALISATION_MODAL',
  HIDE_GEOLOCALISATION_MODAL: 'logistic/HIDE_GEOLOCALISATION_MODAL',
  CHECK_EXIST_BON_TRANSPORT: 'logistic/CHECK_EXIST_BON_TRANSPORT',
  CLEAN_GEOLOCALISATION: 'CLEAN_GEOLOCALISATION',
  RESET_BON_TRANSPORT: 'logistic/RESET_BON_TRANSPORT',
};
